import { render, staticRenderFns } from "./SquadraTavolo.vue?vue&type=template&id=91512a04&scoped=true&"
import script from "./SquadraTavolo.vue?vue&type=script&lang=js&"
export * from "./SquadraTavolo.vue?vue&type=script&lang=js&"
import style0 from "./SquadraTavolo.vue?vue&type=style&index=0&id=91512a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91512a04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91512a04')) {
      api.createRecord('91512a04', component.options)
    } else {
      api.reload('91512a04', component.options)
    }
    module.hot.accept("./SquadraTavolo.vue?vue&type=template&id=91512a04&scoped=true&", function () {
      api.rerender('91512a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SquadraTavolo.vue"
export default component.exports